import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { Button } from '../../../Zemplin/General/Button';
import {
  DsiSvgIcon as SvgIcon,
  DsiIconType as IconType,
  TextP,
  FlexRowCenterVertical,
} from '../../../..';
import { __ } from 'react-i18n';
import { useState } from 'react';
import { InfoText, InfoType } from '../../General/InfoText';

interface Props {
  code: string;
  onCodeChanged: any;
  theme: any;
  addCode: any;
  removeCode: any;
  activeCoupon: any;
  isFetching: boolean;
  couponError?: string | null;
  itemsRestrictions?: any;
}

function Coupon({
  code,
  onCodeChanged,
  theme,
  addCode,
  removeCode,
  activeCoupon,
  isFetching,
  couponError,
  itemsRestrictions
}: Props) {
  const [isButton, setIsButton] = useState(true);
  const [isForm, setIsForm] = useState(false);
  const [isCode, setIsCode] = useState(!!activeCoupon);
  const [couponWasUsed, setCouponWasUsed] = useState(false);

  const onCodeChange = e => {
    onCodeChanged(e.target.value);
  };

  const closeCode = () => {
    removeCode(activeCoupon.card_number);
    setIsCode(false);
    setIsForm(false);
    onCodeChanged('');
    setIsButton(true);
    setCouponWasUsed(false);
  };

  const onButtonClick = () => {
    setIsButton(false);
    setIsForm(true);
  };

  const handleUseCode = () => {
    if (code && code !== '') {
      addCode(code);
      setCouponWasUsed(true);
      // setIsForm(false);
      // setIsCode(true);
    }
  };

  return (
    <>
      {!isFetching && couponError && !activeCoupon && (
        <InfoText
          type={InfoType.ERROR}
          info={
            couponError ? couponError : __('Nepodarilo sa aplikovať poukážku.')
          }
          marginBottom={0}
        />
      )}
      <Wrapper>
        {!activeCoupon ? (
          <NotUsedCoupon>
            {isButton ? (
              <StyledButton isVisible={true} onClick={onButtonClick}>
                <SvgIcon
                  icon={IconType.percentage}
                  fill={theme.cart.cartSummary.primary}
                  marginRight={16}
                  width={24}
                  height={24}
                  cursor={'pointer'}
                />
                <ButtonText>{__('Mám zľavový kód')}</ButtonText>
              </StyledButton>
            ) : (
              <StyledForm isVisible={true}>
                <Input
                  type="text"
                  value={code}
                  placeholder={__('Zadajte zľavový kód')}
                  /* tslint:disable-next-line:jsx-no-lambda */
                  onChange={e => {
                    onCodeChange(e);
                  }}
                />
                <SubmitButton onClick={handleUseCode}>
                  {__('Použiť')}
                </SubmitButton>
              </StyledForm>
            )}
          </NotUsedCoupon>
        ) : (
          <><UsedCoupon isVisible={true}>
            <FlexRowCenterVertical>
              <SvgIcon
                icon={IconType.percentage}
                fill={'#36BF91'}
                marginRight={16}
                width={24}
                height={24}
                cursor={'pointer'}
              />
              <ButtonText>{activeCoupon.card_number}</ButtonText>
            </FlexRowCenterVertical>
            <SvgIcon
              onClick={closeCode}
              icon={IconType.close}
              fill={'#414141'}
              width={20}
              height={20}
              cursor={'pointer'}
            />
          </UsedCoupon>

          {itemsRestrictions?.length?
            itemsRestrictions.map(itemRestriction => {
              return <ItemRestriction> {itemRestriction.error.message}  </ItemRestriction>
            })
            :<></>
          }
          </>

        )}
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: ${rem(32)};
`;

const StyledButton = styled(Button)<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: ${rem(4)};
`;

const ButtonText = styled(TextP)`
  font-size: ${rem(16)};
  font-weight: 500;
  ${({ theme }) => theme.mediab.m810`
    font-size: ${rem(14)};
  `}
`;

const Input = styled.input`
  width: 100%;
  height: 100%;
  padding-left: ${rem(16)};
  border: 0;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: ${rem(4)} 0 0 ${rem(4)};
  font-size: ${rem(16)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.primary};
  &::placeholder {
    color: ${({ theme }) => theme.colors.placeholder};
  }
  ${({ theme }) => theme.mediab.m810`
    font-size: ${rem(14)};
  `}
`;

const SubmitButton = styled(Button)`
  height: 100%;
  font-size: ${rem(16)};
  font-weight: 500;
  background-color: ${({ theme }) => theme.colors.successColor};
  color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 0 ${rem(4)} ${rem(4)} 0;
  min-width: ${rem(100)};
  ${({ theme }) => theme.mediab.m810`
    font-size: ${rem(14)};
  `}
`;

const StyledForm = styled.div<{ isVisible: boolean }>`
  width: 100%;
  height: 100%;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  flex-direction: row;
`;

const UsedCoupon = styled(FlexRowCenterVertical)<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0 ${rem(16)};
  width: 100%;
  justify-content: space-between;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: ${rem(4)};
  height: ${rem(56)};
`;

const NotUsedCoupon = styled(FlexRowCenterVertical)<{ isVisible: boolean }>`
  height: ${rem(56)};
`

const ItemRestriction = styled.div`
  padding: 12px;
  margin-top: 12px;
  border: 0;
  background-color: #FFFFFF;
  box-shadow: 0px 1px 4px rgba(0,0,0,0.08);
  border-radius: 0.25rem;
  position: relative;
`

const CouponWithTheme: any = withTheme(Coupon);
export { CouponWithTheme as Coupon };
